import { FlexGrid } from '@grapecity/wijmo.grid';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1300Component } from '../kymw1300.component';
import { KYMW1300GetSearchSelectedListModel } from './kymw1300-get-search-selected-list.model';
import { KYMW1300SelectedListComponent } from '../kymw1300-selected-list/kymw1300-selected-list.component';
import { PlanNumModel } from './plan-num.model';
import { SelectedGoodsListModel, SelectedGoodsModel } from './selected-goods.model';

/**
 * 商品企画マスタ画面　選定済一覧の値を管理するクラス
 *
 * @export KYMW1300SelectedListModel
 * @class KYMW1300SelectedListModel
 */
export class KYMW1300SelectedListModel {

  kymw1300Component: KYMW1300Component;
  kymw1300_03Cmp: KYMW1300SelectedListComponent;

  // 画面制御用
  public searchFlg: boolean = <boolean>false;                                  // 検索フラグ(true：検索済、false：未検索)

  // 画面バインド用変数
  public dispMode: string = <string>'1';                                        // 表示モード
  public orderNumQuotaCode: string = <string>'';                                // 注文コード割当コード

  public goodsNumCatalogId: string = <string>'';                                // 商品点数・企画回
  public goodsNumMedia: string = <string>'';                                    // 商品点数・媒体
  public goodsNumListName: string = <string>'';                                 // 商品点数・選定済一覧名
  public goodsNumList: string = <string>'';                                     // 商品点数・選定済一覧

  public budgetPrice: string = <string>'';                                      // 予算・金額
  public budgetGp: string = <string>'';                                         // 予算・粗利

  public planPrice: string = <string>'';                                        // 計画・総額・金額
  public planGp: string = <string>'';                                           // 計画・総額・粗利

  public planPriceBudgetRatio: string = <string>'';                             // 計画・予算比・金額
  public planGpBudgetRatio: string = <string>'';                                // 計画・予算比・粗利

  public planGpPreviousYearRatio: string = <string>'';                          // 計画・GP・前年比

  public planGpr: string = <string>'';                                          // 計画・GPR・今年
  public planGprPreviousYearRatio: string = <string>'';                         // 計画・GPR・前年比

  public planAvg: string = <string>'';                                          // 計画・点単価・今年
  public planAvgYearRatio: string = <string>'';                                 // 計画・点単価・前年比

  public totalNum: number = 0;                                               // 件数表示・総件数
  public startDispNum: number = 0;                                           // 件数表示・表示開始件数
  public endDispNum: number = 0;                                             // 件数表示・表示終了件数

  public displayItem: string = <string>'1';                                     // 表示項目
  public displayItemSet: Array<any> = new Array<any>();                         // 表示項目セット

  public selectedList: Array<any> = new Array<any>();                           // 選定済リスト

  // 検索条件
  public accessDispMode: string = <string>'1';                                  // 表示モード(1：部門、2：ページ、3：バイヤー)
  public accessCoopCode: string = <string>'';                                   // 生協コード
  public accessClassCode: string = <string>'';                                  // 部門コード
  public accessMiddleClassCode: string = <string>'';                            // 中分類コード
  public accessSmallClassCode: string = <string>'';                             // 小分類コード
  public accessPageNo: string = <string>'';                                     // ページ番号
  public accessBuyerCode: string = <string>'';                                  // バイヤーコード
  public accessNextGuideCheckFlg: string = <string>'0';                         // 次回案内チェックフラグ(0：チェックしない、1：チェックする)
  public accessPage: string = <string>'';                                       // 表示開始ページ
  public accessSortItem: string = <string>'';                                   // ソート項目名
  public accessSortOrder: string = <string>'';                                  // 昇順降順区分(ASC, DESC)
  public accessOrderNumQuotaCode: string = <string>'';                          // 注文コード割当コード
  public orderClientCode: string = <string>'';                                  // 発注先・取引先コード
  public orderClientKanji: string = <string>'';                                 // 発注先・取引先名称
  public payeeClientCode: string = <string>'';                                  // 支払先・取引先コード
  public payeeClientKanji: string = <string>'';                                 // 支払先・取引先名称
  public kikakuRenrakuStatus: string = <string>'';                              // 企画連絡ステータス

  constructor() {
    // 表示項目セット
    this.displayItemSet.push({ label: 'パターン１', data: '1' });
    this.displayItemSet.push({ label: 'パターン２', data: '2' });
    this.displayItemSet.push({ label: 'パターン３', data: '3' });
  }

  /**
   * 計画数一覧の反映処理
   *
   * @param data 計画数一覧取得APIレスポンス
   */
  public updatePlanNumList(data: PlanNumModel): void {
    this.goodsNumCatalogId = PlessViewUtilsSub.numberToString(data.GoodsNumCatalogId);
    this.goodsNumMedia = PlessViewUtilsSub.numberToString(data.GoodsNumMedia);
    this.goodsNumList = PlessViewUtilsSub.numberToString(data.GoodsNumList);
    this.budgetPrice = PlessViewUtilsSub.numberToString(data.BudgetPrice);
    this.budgetGp = PlessViewUtilsSub.numberToString(data.BudgetGp);
    this.planPrice = PlessViewUtilsSub.numberToString(data.PlanPrice);
    this.planPriceBudgetRatio = PlessViewUtilsSub.numberToString(data.PlanPriceBudgetRatio);
    this.planGp = PlessViewUtilsSub.numberToString(data.PlanGp);
    this.planGpBudgetRatio = PlessViewUtilsSub.numberToString(data.PlanGpBudgetRatio);
    this.planGpPreviousYearRatio = PlessViewUtilsSub.numberToString(data.PlanGpPreviousYearRatio);
    this.planGpr = PlessViewUtilsSub.numberToString(data.PlanGpr);
    this.planGprPreviousYearRatio = PlessViewUtilsSub.numberToString(data.PlanGprPreviousYearRatio);
    this.planAvg = PlessViewUtilsSub.numberToString(data.PlanAvg);
    this.planAvgYearRatio = PlessViewUtilsSub.numberToString(data.PlanAvgYearRato);

    // リスト名の編集を行う
    let listName = String('未指定');

    // 表示モードのチェック
    switch (Number(this.accessDispMode)) {
      case 1:                                                                   // 部門モード
        // 検索条件・小分類コード、中分類コード、部門コードのチェック
        if (!PlessViewUtilsSub.isEmpty(this.accessSmallClassCode)) {            // 小分類コードの指定ありの場合
          listName = this.kymw1300Component.kymw1300_03.cmb_SmallClassCode.selectedSmallClassCode;
        } else if (!PlessViewUtilsSub.isEmpty(this.accessMiddleClassCode)) {    // 中分類コードの指定ありの場合
          listName = this.kymw1300Component.kymw1300_03.cmb_MiddleClassCode.selectedMiddleClassCode;
        } else if (!PlessViewUtilsSub.isEmpty(this.accessClassCode)) {          // 部門コードの指定ありの場合
          listName = this.kymw1300Component.kymw1300_03.cmb_ClassCode.selectedClassCode;
        } else {                                                                // 指定ありの場合
          listName = String('全部門');
        }
        break;

      case 2:                                                                   // ページモード
        // 検索条件・ページ番号(NOT：未掲載、ALL：全て)のチェック
        if (this.accessPageNo === 'ALL') {                                      // 「ALL：全て」の場合
          listName = String('全頁');
        } else if (this.accessPageNo === 'NOT') {                               // 「NOT：未掲載」の場合
          listName = String('非掲載');
        } else if (!PlessViewUtilsSub.isEmpty(this.accessPageNo)) {             // 上記以外の指定ありの場合
          listName = this.kymw1300Component.kymw1300_03.cmb_PageNo.selectedPageNum;
        }
        break;

      case 3:                                                                   // バイヤーモード
        // 検索条件・バイヤーコードのチェック
        if (!PlessViewUtilsSub.isEmpty(this.accessBuyerCode)) {                 // 指定ありの場合
          listName = this.kymw1300Component.kymw1300_03.cmb_buyerCode.selectedCodeValue;
        } else {                                                                // 指定なしの場合
          listName = String('全バイヤー');
        }
        break;

      default:
        break;
    }

    this.goodsNumListName = listName;

    // 『予算計画実績表』画面再表示
    if(this.kymw1300Component.isOpened('KYMW1307')){
      this.kymw1300Component.refleshTargetWindow(String('KYMW1307'), () => {
        // 『予算計画実績表』画面再表示後に処理を行う
        this.kymw1300Component.refleshTargetWindow()
      });
    }
  }


  /**
   * 選定済一覧のクリア処理
   *
   * @memberof KYMW1300SelectedListModel
   */
  public clearList(): void {
    // 検索条件クリア
    this.searchFlg = false;                                                     // 検索フラグ
    this.accessDispMode = <string>'1';                                          // 表示モード(1：部門、2：ページ、3：バイヤー)
    this.accessCoopCode = <string>'';                                           // 生協コード
    this.accessClassCode = <string>'';                                          // 部門コード
    this.accessMiddleClassCode = <string>'';                                    // 中分類コード
    this.accessSmallClassCode = <string>'';                                     // 小分類コード
    this.accessPageNo = <string>'';                                             // ページ番号
    this.accessBuyerCode = <string>'';                                          // バイヤーコード
    this.accessNextGuideCheckFlg = <string>'0';                                 // 次回案内チェックフラグ(0：チェックしない、1：チェックする)
    this.accessPage = <string>'';                                               // 表示開始ページ
    this.accessSortItem = <string>'';                                           // ソート項目名
    this.accessSortOrder = <string>'';                                          // 昇順降順区分(ASC, DESC)
    this.accessOrderNumQuotaCode = <string>'';                                  // 注文コード割当コード
    this.orderClientCode = <string>'';                                          // 発注先・取引先コード
    this.orderClientKanji = <string>'';                                         // 発注先・取引先名称
    this.payeeClientCode = <string>'';                                          // 支払先・取引先コード
    this.payeeClientKanji = <string>'';                                         // 支払先・取引先名称

    // 計画数一覧クリア
    this.goodsNumCatalogId = <string>'';                                        // 商品点数・企画回
    this.goodsNumMedia = <string>'';                                            // 商品点数・媒体
    this.goodsNumListName = <string>'';                                         // 商品点数・選定済一覧名
    this.goodsNumList = <string>'';                                             // 商品点数・選定済一覧
    this.budgetPrice = <string>'';                                              // 予算・金額
    this.budgetGp = <string>'';                                                 // 予算・粗利
    this.planPrice = <string>'';                                                // 計画・総額・金額
    this.planGp = <string>'';                                                   // 計画・総額・粗利
    this.planPriceBudgetRatio = <string>'';                                     // 計画・予算比・金額
    this.planGpBudgetRatio = <string>'';                                        // 計画・予算比・粗利
    this.planGpPreviousYearRatio = <string>'';                                  // 計画・GP・前年比
    this.planGpr = <string>'';                                                  // 計画・GPR・今年
    this.planGprPreviousYearRatio = <string>'';                                 // 計画・GPR・前年比
    this.planAvg = <string>'';                                                  // 計画・点単価・今年
    this.planAvgYearRatio = <string>'';                                         // 計画・点単価・前年比

    // 件数表示クリア
    this.totalNum = 0;                                                       // 件数表示・総件数
    this.startDispNum = 0;                                                   // 件数表示・表示開始件数
    this.endDispNum = 0;                                                     // 件数表示・表示終了件数

    // 選定済一覧クリア
    this.selectedList = new Array<any>();                                       // 選定済リスト
  }

  /**
   * 選定済一覧の反映処理
   *
   * @param data 選定済一覧情報
   * @param vo 選定済一覧検索条件VO
   * @param grid 処理対象データグリッド
   */
  public updateSelectedList(data: SelectedGoodsListModel, vo: KYMW1300GetSearchSelectedListModel): void {

    // 取得情報反映処理
    this.searchFlg = true;                                                      // 検索フラグ
    this.accessDispMode = vo.dispMode;                                          // 表示モード(1：部門、2：ページ、3：バイヤー)
    this.accessCoopCode = vo.coopCode;                                          // 生協コード
    this.accessClassCode = vo.classCode;                                        // 部門コード
    this.accessMiddleClassCode = vo.middleClassCode;                            // 中分類コード
    this.accessSmallClassCode = vo.smallClassCode;                              // 小分類コード
    this.accessPageNo = vo.pageNo;                                              // ページ番号(NOT：未掲載、ALL：全て)
    this.accessBuyerCode = vo.buyerCode;                                        // バイヤーコード
    this.accessNextGuideCheckFlg = vo.nextGuideCheckFlg;                        // 次回案内チェックフラグ(0：チェックしない、1：チェックする)
    this.accessPage = vo.page;                                                  // 表示開始ページ
    this.accessSortItem = vo.sortItem;                                          // ソート項目名
    this.accessSortOrder = vo.sortOrder;                                        // 昇順降順区分(ASC, DESC)
    this.accessOrderNumQuotaCode = vo.orderNumQuotaCode;                        // 注文コード割当コード
    this.orderClientCode = vo.orderClientCode;                                  // 発注先・取引先コード
    this.orderClientKanji = vo.orderClientKanji;                                // 発注先・取引先名称
    this.payeeClientCode = vo.payeeClientCode;                                  // 支払先・取引先コード
    this.payeeClientKanji = vo.payeeClientKanji;                                // 支払先・取引先名称

    // 選定済一覧を保持
    if (data == null || data.SelectedList == null) {                           // 該当データなしの場合

      // 件数表示クリア
      this.totalNum = 0;                                                     // 件数表示・総件数
      this.startDispNum = 0;                                                 // 件数表示・表示開始件数
      this.endDispNum = 0;                                                   // 件数表示・表示終了件数

      // 選定済一覧
      this.selectedList = new Array<any>();                                     // 選定済リスト
    } else {                                                                    // 該当データありの場合

      // 件数表示を設定
      this.totalNum = data.TotalNum;                                         // 件数表示・総件数
      this.startDispNum = data.StartDispNum;                                 // 件数表示・表示開始件数
      this.endDispNum = data.EndDispNum;                                     // 件数表示・表示終了件数

      // 選定済一覧
      this.selectedList = new Array<any>();                                     // 選定済リスト

      for (let i = Number(0); i < data.SelectedList.length; i++) {
        this.selectedList.push(this.editGoodsInfo(data.SelectedList[i]));
      }
    }
  }

  /**
   * 選定商品情報書式編集
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof KYMW1300SelectedListModel
   */
  private editGoodsInfo(data: SelectedGoodsModel): SelectedGoodsModel {
    const value: string = data.Status;
    if (value === '0' || value === '') {
      data.DispStatus = '';
    } else if (value === '1') {
      data.DispStatus  = '仮';
    } else if (value === '2') {
      data.DispStatus  = '選';
    } else if (value === '3') {
      data.DispStatus  = '他';
    } else if (value === '4') {
      data.DispStatus  = 'Ｗ';
    } else if (value === '9') {
      data.DispStatus  = '外';
    }
    return data;
  }

}
